'use strict';

module.exports = Backbone.Model.extend({
    initialized: false,
    action: null,
    actions: {
        'save': 'freqPassNotifSaved',
        'delete': 'freqPassNotifDelete',
        'error': 'freqPassNotifFatalError',
    },
    userDTO: null,
    bindPassengerDetail: false,
    templateSeted: false,
    travellerTitle: ['MR', 'MRS', 'MS'],
    travellerPhonePattern: '^[0-9]{7,13}$',
    userID: null,
    validationTypes: {
        REGEX_VALIDATOR: 'REGEX_VALIDATOR',
        NULL_VALIDATOR: 'NULL_VALIDATOR',
    },
    traveller: {
        buyer: false,
        typeOfTraveller: 'ADULT',
        frequentFlyerList: [],
        profile: {
            gender: '',
            title: '',
            name: '',
            middleName: null,
            firstLastName: '',
            secondLastName: null,
            birthDate: null,
            prefixPhoneNumber: null,
            phoneNumber: null,
            prefixAlternatePhoneNumber: null,
            mobilePhoneNumber: null,
            alternatePhoneNumber: null,
            isDefault: false,
            cpf: null,
            nationalityCountryCode: null,
            identificationList: [],
            address: null,
        },
        importedFromLocal: false,
    },
    address: {
        address: null,
        addressType: '-',
        city: null,
        country: null,
        postalCode: null,
        isPrimary: true,
        alias: null,
        state: null,
    },
});
